import { createContext } from 'react';
import { FlexyFilterValue } from '../DatatableHeader';

type FlexyFilterContextType = {
    rawValue: FlexyFilterValue;
    setRawValue: (rawValue: FlexyFilterValue) => void;
    selectedItem: unknown;
    setSelectedItem: (item: unknown) => void;
};

export const FlexyFilterContext = createContext<FlexyFilterContextType>({
    rawValue: null,
    setRawValue: () => {},
    selectedItem: null,
    setSelectedItem: () => {},
});
